import api from "../api/axiosInstance";

export const createOrUpdateProfile = async (id, profileData) => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));

    let response;

    // ==============================
    // UPDATE PROFILE
    // ==============================
    if (id) {
      response = await api.put(`/profiles/update/${id}`, profileData);
      return response.data;
    }

    // ==============================
    // CREATE PROFILE
    // ==============================
    if (user?.role === "admin") {
      response = await api.post("/profiles/create", profileData);
    } else {
      response = await api.post("/profiles/create", profileData);
    }

    return response.data;

  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Failed to save profile";

    throw new Error(message);
  }
};

//get profile by id
export const getProfileById = async (id) => {
  try {
    const response = await api.get(`/profiles/${id}`);
    return response.data;
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Failed to fetch profile";

    throw new Error(message);
  }
};

//delete profile by id
export const deleteProfileById = async (id) => {
  try {
const response = await api.delete(`/profiles/delete/${id}`);
    return response.data;
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Failed to delete profile";

    throw new Error(message);
  }
};

//profile image upload
export const uploadProfileImage = async (profileId, formData) => {
  try {
    console.log(profileId, formData);
    
    // const formData = new FormData();
    // formData.append("image", file);
    const response = await api.post(`/users/upload/${profileId}`, formData,{
      headers: {
        "Content-Type": "multipart/form-data",
      }
    });
    return response.data;
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Failed to upload profile image";

    throw new Error(message);
  }
};

// recomended profiles
export const getRecommendedProfiles = async () => {
  try {
    const response = await api.get(`/profiles/matches/recommended`);
    return response.data;
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Failed to fetch recommended profiles";

    throw new Error(message);
  }
};
